import styled from 'styled-components';

const PageContainer = styled.main`
    margin: 0 auto;
    width: 100%;
    height: 100%;
    flex: 1;
`;

export default PageContainer;